var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.payload),function(item,index){return _c('text-area',{key:index,attrs:{"value":item}},[_vm._v(" "+_vm._s(index)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }